import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import { useSiteSettings } from "@/hooks/useSiteSettings";

const SECTIONS = [
  {
    title: "1. Introduction",
    items: [
      "These Terms and Conditions govern your use of the Apex Auto Spares website and the purchase of any products through it.",
      "By accessing this website or placing an order, you agree to be bound by these terms. If you do not agree, please do not use this site.",
    ],
  },
  {
    title: "2. About Us",
    items: [
      "Apex Auto Spares is an independent parts and service specialist supplying used, new and aftermarket engines, transmissions and body parts.",
      "We are based in Winnellie, Darwin NT 0820 and ship Australia-wide to workshops, mechanics and private owners.",
    ],
  },
  {
    title: "3. Products & Fitment",
    items: [
      "All parts are described accurately based on their known make, model and fitment details.",
      "It is the customer's responsibility to confirm the correct part number and fitment for their vehicle before ordering.",
      "Images shown are representative and may not show the exact part you will receive.",
    ],
  },
  {
    title: "4. Pricing & Payment",
    items: [
      "Prices are listed in Australian Dollars (AUD) and include GST where applicable.",
      "All orders are enquiry-based. A member of our team will confirm availability, final price and freight before any payment is taken.",
      "We reserve the right to correct any pricing errors or typographical mistakes.",
    ],
  },
  {
    title: "5. Warranty",
    items: [
      "Used parts carry a 3 month warranty and new parts a 12 month warranty unless otherwise stated.",
      "Warranty covers manufacturing and material defects only, and is subject to our Return Policy.",
    ],
  },
  {
    title: "6. Shipping",
    items: [
      "We ship Australia-wide. Estimated delivery times are provided in good faith but are not guaranteed.",
      "Freight costs are confirmed at the time of your enquiry and may vary based on the size and destination of the item.",
    ],
  },
  {
    title: "7. Limitation of Liability",
    items: [
      "To the maximum extent permitted by law, Apex Auto Spares is not liable for indirect or consequential loss arising from the use of any part or this website.",
      "Nothing in these terms excludes any rights you have under the Australian Consumer Law.",
    ],
  },
  {
    title: "8. Intellectual Property",
    items: [
      "All content on this website, including text, graphics and logos, is the property of Apex Auto Spares and may not be reproduced without permission.",
    ],
  },
  {
    title: "9. Changes to These Terms",
    items: [
      "We may update these Terms and Conditions from time to time. Continued use of the website after changes constitutes acceptance of the revised terms.",
    ],
  },
];

export default function TermsPage() {
  const { site } = useSiteSettings();

  return (
    <div className="min-h-screen bg-white font-body">
      <Navbar />
      <main className="w-full bg-neutral-50">
        <section className="w-full bg-brand-dark py-12 md:py-16">
          <div className="mx-auto max-w-7xl px-4 md:px-6 text-center">
            <span className="text-xs font-medium uppercase tracking-widest text-brand-gold">
              Legal
            </span>
            <h1 className="mt-2 font-heading text-3xl md:text-4xl font-semibold uppercase text-white">
              Terms &amp; Conditions
            </h1>
            <p className="mx-auto mt-3 max-w-2xl text-sm text-white/60 leading-relaxed">
              Please read these terms carefully before using our website or purchasing from{" "}
              {site.site_name}.
            </p>
          </div>
        </section>

        <section className="mx-auto max-w-4xl px-4 md:px-6 py-12 md:py-16">
          <div className="space-y-8">
            {SECTIONS.map((s) => (
              <div key={s.title} className="rounded-lg border border-neutral-200 bg-white p-6 md:p-8">
                <h2 className="font-heading text-lg md:text-xl font-semibold uppercase text-brand-dark">
                  {s.title}
                </h2>
                <ul className="mt-4 space-y-3">
                  {s.items.map((item) => (
                    <li key={item} className="flex items-start gap-3 text-sm text-neutral-600 leading-relaxed">
                      <i className="ri-arrow-right-s-line mt-0.5 text-brand-gold"></i>
                      <span>{item.replace(/Apex Auto Spares/g, site.site_name)}</span>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}